import RadioGroup from "@p-ban/common/src/components/form/radio/RadioGroup"

import ESTIMATE_CONSTANT from "../../../../../constant/estimateConstant"
import estimateField from "../../../../../service/estimateFields/estimateField"
import getDisplayCondition from "../../../../../service/getDisplayCondition"
import type { OneClickFieldProps } from "../../../../../types"
import OneClickField from "../../../../components/1Click/form/OneClickField"
import OneClickFieldMessages from "../../../../components/1Click/form/OneClickFieldMessages"
import OneClickFieldStack from "../../../../components/1Click/form/OneClickFieldStack"
import Radio from "../../../../components/1Click/form/Radio/Radio"
import HELP_LINKS from "../../../../constant/helpLinks"

import img from "./ddrEmc.png"

const DDR_IF_EMC設計 = ({ values, handlers, errors }: OneClickFieldProps) => {
  const { ddrEmc: shouldShow } = getDisplayCondition(values)

  return (
    <OneClickField
      isShow={shouldShow}
      legend={"DDR I/F・\nEMC設計（伝送線路\nシミュレーション\n等）"}
      src={img}
      helpURL={HELP_LINKS["DDR I／F・EMC設計（伝送線路シミュレーション等）"]}
    >
      <RadioGroup name={estimateField.ddrEmc.key} selectedValue={values.ddrEmc} onChange={handlers.radio}>
        <OneClickFieldStack>
          <Radio value={ESTIMATE_CONSTANT["DDR I／F・EMC設計（伝送線路シミュレーション等）"].あり.value}>あり</Radio>
          <Radio value={ESTIMATE_CONSTANT["DDR I／F・EMC設計（伝送線路シミュレーション等）"].なし.value}>なし</Radio>
        </OneClickFieldStack>
      </RadioGroup>
      <OneClickFieldMessages error={errors?.ddrEmc} />
    </OneClickField>
  )
}

export default DDR_IF_EMC設計
